var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconclose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13 .5C19.894.5 25.5 6.107 25.5 13c0 6.892-5.606 12.5-12.5 12.5C6.107 25.5.5 19.892.5 13 .5 6.107 6.107.5 13 .5z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.197 7.724c.239 0 .479.091.661.274l4.359 4.337a.94.94 0 010 1.329l-4.359 4.34a.936.936 0 11-1.322-1.329L14.227 13l-3.691-3.675a.937.937 0 01.661-1.601z",
    fill: "#ED1B2E"
  })));
}

export default SvgIconclose;